import React from 'react';
import { Typography, Divider } from 'antd';

const { Text } = Typography;

interface SidebarSectionProps {
  title: string;
  children: React.ReactNode;
  showDivider?: boolean;
  collapsed?: boolean;
}

export const SidebarSection: React.FC<SidebarSectionProps> = ({
  title,
  children,
  showDivider = true,
  collapsed = false
}) => {
  if (collapsed) {
    return null;
  }

  return (
    <>
      <div style={{ 
        width: '100%', 
        maxWidth: '100%', 
        overflow: 'hidden',
        boxSizing: 'border-box'
      }}>
        <Text strong style={{ 
          fontSize: '14px', 
          color: 'white', 
          marginBottom: '8px', 
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>
          {title}
        </Text>
        <div style={{ 
          width: '100%', 
          maxWidth: '100%', 
          overflow: 'hidden',
          boxSizing: 'border-box'
        }}>
          {children}
        </div>
      </div>
      {showDivider && (
        <Divider style={{ 
          margin: '8px 0', 
          borderColor: 'rgba(255, 255, 255, 0.1)' 
        }} />
      )}
    </>
  );
};
